<li class="btn list-item">
  <h3>{{item.tripNumber}}</h3>
</li>
